(ns practitest.frontend.ts-utils
  (:require [practitest.frontend.common-entities.metadata :refer [get-entity-name]]
            [practitest.frontend.common.i18n :refer [format-translation
                                                     get-translation]]
            [practitest.frontend.common.permissions :as permissions]
            [practitest.frontend.components.notifications :as notifications]
            [practitest.frontend.subs :refer [get-field-by-id]]
            [re-frame.core :as re-frame]
            [goog.functions :as gfunc]))

;; TODO ad subscribe & dispatch
;;   1. Add support for namespace keywords
;;   2. Add support for multiple arguments

;; ;; dispatch
;; (defn string-dispatch [event-name event-data] (dispatch [(keyword event-name) event-data]))

;; ;; subscribe
;; (defn ts-subscribe [event-name]
;;   @(subscribe [(keyword event-name)]))

;; ;; getdb
;; (defn db-for-ts []
;;   (let [current-db @app-db]
;;     (clj->js current-db)))

;; (as->
;;  js/window.pt $
;;   (js->clj $)
;;   (merge $ {:dispatch string-dispatch :getdb db-for-ts :subscribe ts-subscribe})
;;   (clj->js $)
;;   (set! js/window.pt $))

(defn ^:export hasPermission [permission]
  (permissions/has-permission? permission))

(defn ^:export getCljsField [id]
  (clj->js (get-field-by-id id)))

(defn ^:export getTranslation [key default-text]
  (get-translation key default-text))

(defn ^:export getEntityName [entity-type name-type]
  (get-entity-name (keyword entity-type) (keyword name-type)))

(defn ^:export formatTranslation [key default-text args]
  (format-translation (get-translation key default-text)
                      (js->clj args :keywordize-keys true)))

(defn ^:export debounce [f interval opt-scope]
  (gfunc/debounce f interval opt-scope))

(defn ^:export showNotification [type message]

  (case type
    "success" (re-frame/dispatch [::notifications/success2 message])
    "error" (re-frame/dispatch [::notifications/error2 message])
    "warning" (re-frame/dispatch [::notifications/warning2 message])
    "info" (re-frame/dispatch [::notifications/info2 message])))
